export default __webpack_public_path__ + "static/media/chevron-down-outline-16px-white.51df8a9f.svg";